export default __webpack_public_path__ + "static/media/MITRE.d5b7a076.webp";